












































































































































































































































































































































import { editFactory } from '@/main/pages';
import { Pracovnik } from '@/modules/administrace/pracovnik';
import { NakladoveStredisko } from '@/modules/ciselnik/firemni/nakladoveStredisko';
import { ReklamaText } from '@/modules/ciselnik/firemni/reklamaText';
import { Tymprac } from '@/modules/ciselnik/firemni/tymprac';
import DmsTree from '@/main/components/dms/Tree.vue';
import { showNotification, showAlert } from '@/main/utils/notifications';

import _ from 'lodash';

import { DefaultCurrency } from '@/modules/servis/zakazka/components/AdvancePay/constants';

import { UserRole } from '@/main/components/constants';

import { BUTTON_TYPES_ENUM } from '#components/@types/button';

import { NAME, MENU_CODE, TAB_NAMES, TABS, ADVANCE_PAYMNET, TABS_WITH_PERMISSION, SUB_MENU_ID_PROP, UserProfileValid } from './constants';
import { store } from './store/edit';
import { types } from './store/types';
import { apiProvider as uzivatelskyProfilAPIProvider } from './api';


export default editFactory(NAME, store).extend({
	components: {
		PracovnikSelect: Pracovnik.components.Select,
		NakladoveStrediskoSelect: NakladoveStredisko.components.Select,
		ReklamaTextSelect: ReklamaText.components.Select,
		DmsTree,
		TymPracSelect: Tymprac.components.Select,
	},
	data() {
		return {
			nastaveni2Tabs: [],
			nastaveni2ActiveTabName: '',
			treeProps: {
				children: 'Children',
				label: 'Text',
			},
			sucess: BUTTON_TYPES_ENUM.SUCCESS,
			discountLimitConfigValues: null as any | null,
			showOneTimePasswordDialog: false,
			password: null as any | null,
			passwordCheck: '',
			isLoading: false,
			rules: {
				password: { required: true },
				passwordCheck: { required: true },
			},
			tabNames: TAB_NAMES,
		};
	},
	computed: {
		tabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.Nastaveni1)) tabItems.push(TAB_NAMES.NASTAVENI1);
			if (this.hasTabAccess(MENU_CODE, TABS.Nastaveni2)) tabItems.push(TAB_NAMES.NASTAVENI2);
			if (this.hasTabAccess(MENU_CODE, TABS.Nastaveni3)) tabItems.push(TAB_NAMES.NASTAVENI3);
			if (this.hasTabAccess(MENU_CODE, TABS.Rozhrani)) tabItems.push(TAB_NAMES.ROZHRANI);
			if (this.hasTabAccess(MENU_CODE, TABS.DiscountConfig)) tabItems.push(TAB_NAMES.DISCOUNTCONFIG);
			if (!this.isCreateMode && this.hasTabAccess(MENU_CODE, TABS.MenuOperations)) tabItems.push(TAB_NAMES.MENUOPERATIONS);
			if (!this.isCreateMode && this.hasTabAccess(MENU_CODE, TABS.MenuTabs)) tabItems.push(TAB_NAMES.MENUTABS);

			return _.pick(TABS, tabItems);
		},
		nastaveni2TabItems() {
			const tabItems = [];

			if (this.hasTabAccess(MENU_CODE, TABS.SubStringSM)) tabItems.push(TAB_NAMES.SUBSTRINGSM);
			if (this.hasTabAccess(MENU_CODE, TABS.SubStringOV)) tabItems.push(TAB_NAMES.SUBSTRINGOV);
			if (this.hasTabAccess(MENU_CODE, TABS.SubStringNV)) tabItems.push(TAB_NAMES.SUBSTRINGNV);

			return _.pick(TABS, tabItems);
		},
		mutationsMappers(): Record<string, string> {
			return {
				nakladoveStredisko: `${this.storeUri}/${types.mutations.NAKLADOVE_STREDISKO_MAPPER}`,
				mechanik: `${this.storeUri}/${types.mutations.MECHANIK_MAPPER}`,
				pracovnik: `${this.storeUri}/${types.mutations.PRACOVNIK_SELECT_MAPPER}`,
				reklamniTexty: `${this.storeUri}/${types.mutations.REKLAMNI_TEXTY_MAPPER}`,
				reklamniTextyNv: `${this.storeUri}/${types.mutations.REKLAMNI_TEXTY_NV_MAPPER}`,
				TympracId: `${this.storeUri}/${types.mutations.TYM_PRAC_MAPPER}`,
				TympracIdPt: `${this.storeUri}/${types.mutations.TYM_PRAC_PT_MAPPER}`,
			};
		},
		nakladoveStrediskoFilter(): { ProvozovnaId: number | null } {
			return { ProvozovnaId: this.ProvozovnaId };
		},
		setPasswordDisabledConditions(): boolean {
			return !_.isEqual(this.password, this.passwordCheck);
		},
		validatorOneTimePassword(): Function {
			return (this.$refs.oneTimeDialogRef as any).validate;
		},
		getCurrency() {
			this.MenaId = (this.dropdownList.Mena as any).filter((x:any) => x.Text === DefaultCurrency.PrimaryText || x.Text === DefaultCurrency.SecondaryText)[0]?.Value;
			return this.MenaId;
		},
	},
	watch: {
		Text(val) {
			this.titleDetail = val;
		},
	},
	methods: {
		async loadData() {
			this.fetchTableSchemaData(this.dependenciesById);
			this.fetchTableSchemas(this.dependeciesByFilter);
			if (this.isCreateMode) {
				await this.default();
			} else {
				await this.entity();
				await this.getUzvatelPerm();
				this.getUserPermTree();
				this.fetchTableData(this.dependeciesByFilter);
			}
			await this.loadedData();
		},
		localizeContent(items: any) {
			if (Array.isArray(items.Children)) {
				items.Text = this.LocalizeMenu(items.Text);
				items.Children.forEach(this.localizeContent);
			} else {
				items.Text = this.multiKey(items.Text);
			}
		},
		localizeContentForMenuTabs(items: any) {
			if (Array.isArray(items.Children) && items.Children.length > 0 && !TABS_WITH_PERMISSION.includes(items.Text)) {
				items.Text = this.LocalizeMenu(items.Text);
				items.Children.forEach(this.localizeContentForMenuTabs);
			} else {
				items.Text = this.multiKey(items.Text);
			}
		},
		isMenuTabsVisible(items: any) {
			if (Array.isArray(items.Children) && items.Text === ADVANCE_PAYMNET.MainMenuText) {
				items.Children.forEach((m:any) => {
					m.Children.forEach((n:any) => {
						if (n.Text === ADVANCE_PAYMNET.SubMenuText && (this.pracovnik.PracovnikOzn !== (UserRole.SERVICE_ADVISER) && this.pracovnik.PracovnikOzn !== (UserRole.CRE)
						&& this.pracovnik.PracovnikOzn !== (UserRole.ADMIN))) {
							const itemToRemoveIndex = m.Children.findIndex((item:any) => item.Text === ADVANCE_PAYMNET.SubMenuText);
							if (itemToRemoveIndex !== -1) {
  							m.Children.splice(itemToRemoveIndex, 1);
							}
						}
					});
				});
			}
		},
		multiKey(key: string) {
			const labelKey = key.split(', ');
			return labelKey.length > 1 ? this.LocalizeMultiKeyToCommaString(`${labelKey[0]}/${labelKey[1]}`) : this.LocalizePopisostatni(labelKey[0]);
		},
		getUserPermTree() {
			this.menuOperations = this.MenuOperations;
			this.menuTabs = this.MenuTabs;

			this.menuOperations.forEach(this.localizeContent);
			this.menuTabs.forEach(this.localizeContentForMenuTabs);
			const selectOperations = this.SelectedOperations.length > 0
				? this.SelectedOperations
				: this.DefaultOperations;

			const selectTabs = this.SelectedTabs.length > 0
				? this.SelectedTabs
				: this.DefaultTabs;

			selectOperations.forEach((element: any) => this.selectedOperations.push(element.Id));

			const tabIdsHavingAccess :any = [];
			this.SelectedTabsAccess.forEach((element:any) => {
				this.selectedTabsAccess.push(element.Id);
				tabIdsHavingAccess.push(element.TabId);
			});
			(this.$refs.tabsTree as any).setCheckedKeys(this.selectedTabsAccess, false);

			selectTabs.forEach((element: any) => this.selectedTabs.push(element.Id));

			this.selectedTabs = this.selectedTabs.filter((tabId) => !tabIdsHavingAccess.includes(tabId));
			this.selectedTabs = this.selectedTabs.concat(this.selectedTabsAccess);
		},

		async saveClick() {
			if (!this.isCreateMode) {
				const menuOperationIds = (this.$refs.operationsTree as any).getChecked().map((el: any) => el.Id).filter((el: any) => el);
				const menuTabsChecked = (this.$refs.tabsTree as any).getChecked().filter((el:any) => el.hasOwnProperty(SUB_MENU_ID_PROP) && el.Id !== undefined)
					.map((el: any) => el.Id);
				const menuTabsHalfChecked = (this.$refs.tabsTree as any).getHalfCheckedNodes().filter((el:any) => el.hasOwnProperty(SUB_MENU_ID_PROP) && el.Id !== undefined)
					.map((el: any) => el.Id);

				const menuTabIds = menuTabsChecked.concat(menuTabsHalfChecked);
				const menuTabAccessIds = (this.$refs.tabsTree as any).getChecked().filter((el:any) => !el.hasOwnProperty('Children'));
				await this.saveUserPermissions({ menuOperationIds, menuTabIds, menuTabAccessIds });
			}

			const { data: isProfileValid } = await uzivatelskyProfilAPIProvider.isUserUniqueLoginName(this.ZaznamId, this.Login, this.PracovnikId);
			if (isProfileValid == UserProfileValid.LoginInvalid) {
				this.Login = '';
				showAlert({
					message: this.LocalizeChyboveHlasky('Invalid_Login_Name'),
					title: 'Notification',
					options: {
						type: 'info',
					},
				});
			} else if (isProfileValid == UserProfileValid.WorkerInvalid) {
				this.PracovnikIdText = '';
				this.PracovnikOsobniCis = '';
				showAlert({
					message: this.LocalizeChyboveHlasky('Invalid_Worker_Name'),
					title: 'Notification',
					options: {
						type: 'info',
					},
				});
			} else {
				const isValid = await this.validate();
				if (!isValid) return;
				await this.save();
				await this.saveDiscountLimitConfig();
			}
		},
		resetOperations() {
			this.selectedOperations = [];
			(this.$refs.operationsTree as any).reset();
			this.DefaultOperations.forEach((element: any) => this.selectedOperations.push(element.Id));
		},
		resetTabs() {
			this.selectedTabs = [];
			(this.$refs.tabsTree as any).reset();
			this.DefaultTabs.forEach((element: any) => this.selectedTabs.push(element.Id));
		},
		substrLabel(subtrKey: string, moduleKey: string) {
			return `${this.LocalizePopisostatni(subtrKey)} ${this.LocalizePopisostatni(moduleKey)}`;
		},
		substrLabelSM(labelKey: string) {
			return this.substrLabel(labelKey, 'modulSM');
		},
		substrLabelOV(labelKey: string) {
			return this.substrLabel(labelKey, 'modulOV');
		},
		substrLabelNV(labelKey: string) {
			return this.substrLabel(labelKey, 'modulNV');
		},
		provozovnaChange() {
			this.StrednaklOzn = null;
			this.StrednaklOznText = null;
			this.$nextTick(() => {
				(this as any).mainForm.clearValidate();
			});
		},
		async saveDiscountLimitConfig() {
			await uzivatelskyProfilAPIProvider.saveDiscountLimitConfig(this.edit);
		},
		async validateOneTimePassword() {
			let isValid;
			this.validatorOneTimePassword((valid: boolean) => {
				isValid = valid;
			});
			return isValid;
		},
		async handleSetOneTimePassword() {
			const isValid = await this.validateOneTimePassword();
			if (!isValid) {
				return;
			}
			await this.setOneTimePassword();
		},
		async setOneTimePassword() {
			try {
				this.isLoading = true;
				const { data } = await uzivatelskyProfilAPIProvider.setOneTimePassword(this.PracovnikId, this.password);
				this.showNotification({
					title: this.Localize('DMS3_SuccessTitle'),
					message: this.LocalizeChyboveHlasky(data ? 'Hotovo' : 'NoChange'),
					type: data ? 'success' : 'error',
				});
			} catch (error) {
				showNotification({ title: error.name, message: error.message });
			} finally {
				this.showOneTimePasswordDialog = false;
				this.isLoading = false;
			}
		},
		closeOneTimePasswordDialog() {
			this.showOneTimePasswordDialog = false;
			this.password = null;
			this.passwordCheck = '';
		},
	},
});
